var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.show ? _vm.prefixCls + '-open' : ''],
    staticStyle: {
      "position": "relative",
      "display": "inline-block"
    }
  }, [_c('n3-input', {
    ref: "input",
    attrs: {
      "width": _vm.width,
      "name": _vm.name,
      "rules": _vm.rules,
      "placeholder": _vm.placeholder,
      "custom-validate": _vm.customValidate,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "show-clean": _vm.showClean
    },
    on: {
      "focus": _vm._onFocus,
      "blur": _vm._onBlur
    },
    nativeOn: {
      "input": function($event) {
        _vm.update($event)
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.up($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.hit(null)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.reset($event)
      }]
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }), _vm._v(" "), _c('ul', {
    class: (_vm.prefixCls + "-dropdown-menu"),
    style: ({
      width: _vm.dropdownWidth,
      maxHeight: _vm.dropdownHeight
    })
  }, _vm._l((_vm.citems), function(item, index) {
    return _c('li', {
      class: _vm.isActive(index)
    }, [_c('a', {
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.hit(index)
        }
      }
    }, [_c('n3-render', {
      attrs: {
        "context": _vm.context || _vm.$parent._self,
        "template": _vm.itemRender(item)
      }
    })], 1)])
  }))], 1)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-042a3cc0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-042a3cc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Typeahead/n3Typeahead.vue
// module id = 597
// module chunks = 0 1